<template>
  <div class="form">
    <!-- 날짜 선택 -->
    <div class="formBox">
      <p class="formTitle">{{info.name[lang]}}</p>
      <!-- 날짜 -->
      <div class="formGroup isRequired mb15 notranslate">
        <label class="label toCapitalize">{{locale.select_date}}</label>
        <div class="fullCalendar" data-custom="calendar">
          <vc-date-picker
            is-inline
            is-expanded
            v-model="reserve.date"
            mode="date"
            :value="null"
            :attributes="calendarAttr"
            :disabled-dates="disabledDates"
            :locale="ln"
            @input="getReservationInfo" />
        </div>
        <p class="input mt5">{{reserve.date ? setDateFormat(reserve.date) : locale.message_select_date}}</p>
      </div>
      <!-- //날짜 -->
    </div>
    <!-- //날짜 선택 -->
    <!-- 하루에 한번만 예약 가능합니다 -->
    <p v-if="!validate.isStaff && validate.limitPerDay" class="noData toCapitalize notranslate">
      {{locale.reservation_already}}<br>
      {{locale.reservation_limit_per_day}}
    </p>
    <!-- //하루에 한번만 예약 가능합니다 -->
    <!-- 하루에 한번만 예약 가능합니다 -->
    <p v-if="!validate.isStaff && validate.limitPerOta" class="noData toCapitalize notranslate">
      {{locale.reservation_already}}<br>
      {{locale.reservation_limit_per_ota}}
    </p>
    <!-- //하루에 한번만 예약 가능합니다 -->
    <!-- 예약 인원/섹션/자리 선택 -->
    <div v-if="validate.isStaff || (validate.possible && validate.date && space)">
      <div class="formBox">
        <div class="formTitle notranslate">{{locale.select_reservation_detail}}</div>
        <!-- person -->
        <div class="formGroup isRequired notranslate">
          <label class="label toCapitalize">{{locale.reservation_person}}</label>
          <select class="input" v-model="reserve.person">
            <option value="" disabled>{{locale.select_person}}</option>
            <option v-for="person in 8" :key="person" :value="person">{{person}}</option>
            <option value="input">{{locale.direct_input}}</option>
          </select>
          <div v-if="reserve.person === 'input'" class="inputWithBtn mt5">
            <input type="number" class="input" v-model="personInput" @keypress="updatePerson">
          </div>
        </div>
        <!-- //person -->
        <!-- messages -->
        <!-- 인원선택 하세요 -->
        <p v-if="!validate.person" class="noData toCapitalize notranslate">
          {{locale.message_select_person}}
        </p>
        <!-- 선택한 인원으로 예약 가능한 공간이 없음 -->
        <p v-else-if="!validate.isStaff && validate.person && section.length === 0" class="noData toCapitalize notranslate">
          {{locale.nodata_reservation_section}}
        </p>
        <!-- 모든 시간 예약 불가 -->
        <p v-else-if="!validate.isStaff && time.filter(x => !x.disabled).length === 0" class="noData toCapitalize notranslate">
          {{locale.nodata_reservation_time}}
        </p>
        <!-- //messages -->
        <div v-if="validate.person && section.length > 0 && time.filter(x => !x.disabled).length > 0">
          <!-- section -->
          <div v-if="section.length > 0" class="formGroup isRequired mt15">
            <label class="label toCapitalize notranslate">{{locale.reservation_section}}</label>
            <select v-if="validate.person" class="input" v-model="reserve.section">
              <option value="" disabled class="notranslate toCapitalize">{{locale.select_section}}</option>
              <option
                v-for="s in section"
                :key="s.id"
                :value="s.id">
                {{s.name[lang]}}
              </option>
            </select>
            <p v-else class="input disabledInputMessage toCapitalize notranslate">{{locale.message_select_person}}</p>
            <span class="translateTxt"
              v-for="s in section"
              :key="s.id"
              :value="s.id">
              {{s.name[lang]}}
            </span>
          </div>
          <!-- //section -->
          <!-- time -->
          <div v-if="time.length > 0" class="formGroup isRequired mt15 notranslate">
            <label class="label toCapitalize">{{locale.reservation_time}}</label>
            <select v-if="validate.section" class="input" v-model="reserve.time">
              <option value="" disabled class="notranslate toCapitalize">{{locale.select_time}}</option>
              <option
                v-for="t in time"
                :key="t.timeId"
                :value="t.timeId"
                :disabled="t.disabled">
                {{t.label && t.label[lang].length > 0 ? `${t.label[lang]} - ${t.name}` : t.name}}
              </option>
            </select>
            <p v-else class="input disabledInputMessage toCapitalize">{{locale.message_select_section}}</p>
            <div v-if="status.isVisiable" class="statusMessage mt10">
              <span>
                {{locale.reservation_status}}: {{status.current}}/{{status.total}}
                <i v-if="validate.isStaff && status.overbooking > 0">Overbooking: {{status.overbooking}}</i>
              </span>
            </div>
          </div>
          <!-- //time -->
          <!-- place -->
          <div v-if="validate.section && validate.time">
            <!-- 선택한 시간으로 예약 가능한 자리가 없음 -->
            <p v-if="!validate.isStaff && place.filter(x => !x.disabled && x.isPerson && x.isRemain && x.isSelectable).length === 0" class="noData toCapitalize notranslate">
              {{locale.nodata_reservation_place}}
            </p>
            <div v-else>
              <!-- place & seat -->
              <div v-if="!current.section.autoAssign && seatMap.seats.length" class="formGroup isRequired mt15">
                <label class="label toCapitalize notranslate">{{locale.reservation_place}}</label>
                <SeatMap
                  :locale="locale"
                  :lang="lang"
                  :seats="seatMap.seats"
                  :objects="seatMap.objects"
                  :info="seatMap.info"
                  :activeTarget="reserve.seat"
                  :count="info.multiple ? person : 1"
                  @activeSeat="activeSeat" />
                <!-- <p class="input mt5">{{reserve.seat ? getSeatName() : locale.message_select_place}}</p> -->
              </div>
              <!-- //place & seat -->
              <!-- place
              <div v-if="!current.section.autoAssign && place.length > 1" class="formGroup isRequired mt15">
                <label class="label toCapitalize notranslate">{{locale.reservation_place}}</label>
                <select v-if="validate.time" class="input" v-model="reserve.place" @change="setSeat">
                  <option value="" disabled class="notranslate">{{locale.select_place}}</option>
                  <option
                    v-for="p in place"
                    :key="p.placeId"
                    :value="p.placeId"
                    :disabled="p.disabled || !p.isSelectable || !p.isPerson || !p.isRemain">
                    {{p.name[lang]}}
                  </option>
                </select>
                <p v-else class="input disabledInputMessage toCapitalize notranslate">{{locale.message_select_section}}</p>
              </div>
              //place -->
            </div>
          </div>
          <!-- //place -->
        </div>
      </div>
    </div>
    <!-- //예약 인원/섹션/자리 선택 -->
    <!-- 선택한 인원으로 예약 가능한 자리가 없음 -->
    <p v-if="!validate.isStaff && info.multiple && validate.section && validate.place && validate.time && !validate.seat" class="noData toCapitalize notranslate">
      {{!validate.multipleSeat ? locale.select_seat_reservation_person : locale.nodata_reservation_section}}
    </p>
    <!-- 선택한 시간으로 예약 가능한 자리가 없음 -->
    <p v-if="!validate.isStaff && info.multiple && validate.section && validate.place && !validate.time" class="noData toCapitalize notranslate">
      {{locale.nodata_reservation_place}}
    </p>
    <!-- 예약자 정보 입력 -->
    <div v-show="validate.isStaff || (validate.person && validate.time && validate.section && validate.place && validate.seat)" class="formBox">
      <div class="formTitle toCapitalize notranslate">{{locale.booker_information}}</div>
      <!-- 예약자 정보:: 이름 -->
      <div class="notranslate">
        <div class="formGroup isRequired mt15">
          <label class="label toCapitalize">{{locale.first_name}}</label>
          <input type="text" class="input" v-model="reserve.firstName" required>
        </div>
        <div class="formGroup isRequired mt15">
          <label class="label toCapitalize">{{locale.last_name}}</label>
          <input type="text" class="input" v-model="reserve.lastName" required>
        </div>
      </div>
      <!-- //예약자 정보:: 이름 -->
      <!-- 예약자 정보:: 연락처 -->
      <div v-if="info.bookerTel" class="formGroup isRequired mt15 notranslate telInputWithSearch">
        <label class="label toCapitalize">{{locale.telephone}}</label>
        <div v-show="openCountry" class="searchCountry">
          <input
            type="text"
            class="input"
            placeholder="country name or code"
            ref="searchInput"
            v-model="searchCountry"
            @focus.stop
            @click.stop
            @keyup.enter="setSearchCountry" />
          <button type="button" class="btn btnSearch" @click.stop="setSearchCountry">
            {{locale.search}}
          </button>
        </div>
        <vue-tel-input
          class="telInput input"
          ref="telInput"
          :mode="'national'"
          :autoDefaultCountry="true"
          :preferredCountries="filteredCountry"
          :validCharactersOnly="true"
          @input="inputTel"
          @open="toggleCountry(true)"
          @close="toggleCountry(false)"></vue-tel-input>
      </div>
      <!-- //예약자 정보:: 연락처 -->
      <!-- 예약자 정보:: 이메일 -->
      <div v-if="info.bookerEmail" class="formGroup isRequired mt15 notranslate">
        <label class="label toCapitalize">{{locale.email}}</label>
        <input type="email" class="input" v-model="reserve.email" required>
      </div>
      <!-- //예약자 정보:: 이메일 -->
    </div>
    <div v-if="info.infoTxt[lang].length">
      <pre v-html="info.infoTxt[lang]" class="messageBox mt15 toCapitalize"></pre>
    </div>
    <!-- //예약자 정보 입력 -->
    <!-- 예약하기 -->
    <div class="formGroup btns mt30 notranslate">
      <button type="button" class="btn btnRound btnFull toCapitalize" :disabled="!validate.result" @click="confirmSummary(true)">{{locale.reservation_confirm}}</button>
      <p v-if="!isStaff && !info.preArrival && !roomKey" class="validateMessage">{{locale.invalid_key}}</p>
    </div>
    <!-- //예약하기 -->
    <!-- 예약내용 레이어 -->
    <Summary v-if="summary"
      :locale="locale"
      :lang="lang"
      :summary="summary"
      :summaryDisplay="summaryDisplay"
      @confirm="confirmSummary" />
    <!-- //예약내용 레이어 -->
  </div>
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import Summary from '@/components/Reservation/Summary'
import SeatMap from '@/components/Reservation/SeatMap'

export default {
  name: 'ReservationForm',
  props: [
    'lang',
    'ln',
    'locale',
    'info',
    'roomKey',
    'isPublic'
  ],
  components: {
    Summary,
    SeatMap
  },
  computed: {
    isStaff () {
      const staff = this.$store.state.authentication.staff
      return staff
    },
    dateFormat () {
      return this.$store.getters['common/getDateFormat']
    },
    filteredCountry () {
      const word = regExp.replaceAllEmpty(this.searchCountry).toLowerCase()
      const findCountry = this.countryList.filter(x => {
        const iso2 = regExp.replaceAllEmpty(x.iso2).toLowerCase().includes(word)
        const dialCode = regExp.replaceAllEmpty(`+${x.dialCode}`).toLowerCase().includes(word)
        const name = regExp.replaceAllEmpty(x.name).toLowerCase().includes(word)
        return word.length > 0 && (iso2 || dialCode || name)
      }).map(x => x.iso2)
      return findCountry
    },
    // 달력 선택불가 날짜 설정
    disabledDates () {
      const weekday = this.info.dayOfWeek.filter(x => !x.available).map(x => x.weekday)
      const disabledDays = this.info.disabledDays.map(x => x.id)
      const allowedToday = this.info.allowedToday
      const range = Number(regExp.numberOnly(this.info.range))
      const rangeFrom = allowedToday
        ? moment().set({ hour: 0, minute: 0 }).add(-1, 'days')
        : moment().set({ hour: 0, minute: 0 })
      const rangeTo = moment().set({ hour: 0, minute: 0 }).add(range + 1, 'days')
      let dates = [{ weekdays: weekday }]
      dates.push({
        start: null,
        end: rangeFrom.toISOString()
      })
      dates.push({
        start: rangeTo.toISOString(),
        end: null
      })
      if (disabledDays.length) {
        disabledDays.forEach(function (x) {
          dates.push(new Date(x))
        })
      }
      return dates
    },
    person () {
      return this.reserve.person !== '' && this.reserve.person !== 'input'
        ? Number(this.reserve.person)
        : Number(this.personInput)
    },
    section () {
      const person = this.person
      const time = this.reserve.time
      const section = this.space.filter(x => x.isSelectable && x.place.filter(p => {
        return Number(p.min) <= person && Number(p.max) >= person
      }).length > 0)
      return section.map(x => {
        return {
          ...x,
          place: x.place.map(p => {
            return {
              ...p,
              isRemain: p.seat.filter(s => {
                return s.time.filter(t => t.timeId === time && t.isSelectable).length > 0 // 현재 시간에 빈자리 있음?
              }).length > 0,
              isPerson: Number(p.min) <= person && Number(p.max) >= person // 현재 선택된 인원 조건에 해당?
            }
          })
        }
      })
    },
    place () {
      const sectionId = this.reserve.section
      const section = this.section.find(x => x.id === sectionId)
      const place = section ? section.place : []
      const person = this.person
      const isMultiple = this.info.multiple
      return place.map(x => {
        return {
          ...x,
          // isSelectable: x.seat.filter(s => s.isSelectable).length >= person
          isSelectable: isMultiple
            ? x.seat.filter(s => s.isSelectable).length >= person
            : x.seat.filter(s => s.isSelectable).length > 0 && x.min <= person && x.max >= person
        }
      })
    },
    seat () {
      const time = this.reserve.time
      const placeId = this.reserve.place
      const place = this.place.find(x => x.placeId === placeId)
      const seat = place ? place.seat : []
      return seat.map(x => {
        return {
          ...x,
          time: time ? x.time.find(x => x.timeId === time) : null,
          isSelectable: time ? x.time.find(x => x.timeId === time).isSelectable : null
        }
      })
    },
    seatMap () {
      const section = this.current.section
      const time = this.reserve.time
      const seatList = section && section.seatMap
        ? section.seatMap.map(x => {
          const place = section.place.find(s => s.placeId === x.placeId) || null
          const seat = place ? place.seat.find(s => s.seatId === x.seatId) : null
          return {
            ...x,
            isSelectable: seat && time ? seat.time.find(x => x.timeId === time).isSelectable : false, // 이 시간 예약 찼음?
            isPerson: place.isPerson // 수용 가능한 인원?
          }
        }).filter(x => section.place.find(p => {
          return (p.placeId && x.placeId) && p.seat.find(s => s.seatId === x.seatId)
        }))
        : null
      return {
        autoAssign: section && section.autoAssign,
        seats: seatList,
        objects: section && section.seatMap ? section.seatObj : null,
        info: {
          showPlaceName: section && section.seatMap ? section.showPlaceName !== false : null,
          showSeatName: section && section.seatMap ? section.showSeatName !== false : null
        }
      }
    },
    isToday () {
      return moment(this.reserve.date).isSame(moment(), 'day')
    },
    time () {
      const timeNow = this.timeNow
      const isToday = this.isToday
      const possibleUpTo = this.info.possibleUpTo
      const uptoTime = this.info.possibleUpToTime
      function disabled (timeBefore, timeNow) {
        return Number(timeNow) > Number(timeBefore)
      }
      return this.info.time.map(x => {
        let isDisabled = false
        if (isToday) { // 오늘 예약 가능?
          if (possibleUpTo) { // 시작시간 이후라도 종료n분전 예약 가능?
            isDisabled = disabled(moment(x.to).add(-(uptoTime), 'minute').format('HHmm'), timeNow)
          } else {
            isDisabled = disabled(moment(x.from).format('HHmm'), timeNow)
          }
        }
        return {
          ...x,
          disabled: isDisabled
        }
      })
    },
    current () {
      const section = this.section.find(x => x.id === this.reserve.section) || null
      const place = this.place.find(x => x.placeId === this.reserve.place) || null
      // const seat = place ? place.seat.filter(x => this.reserve.seat.includes(x.seatId)) : null
      const time = this.time.find(x => x.timeId === this.reserve.time) || null
      return {
        person: this.person,
        section: section,
        place: place,
        // seat: seat,
        time: time
      }
    },
    status () {
      const sectionId = this.reserve.section
      const placeId = this.reserve.place
      const timeId = this.current.time && this.current.time.timeId
      const total = this.current.place && this.current.place.count
      const todayReserved = this.reserved.filter(x => {
        return x.section === sectionId && x.place === placeId && x.time === timeId
      })
      const overbooking = this.info.multiple
        ? todayReserved.filter(x => x.isOverbooking).reduce(function (a, b) {
          return a + Number(b.person)
        }, 0)
        : todayReserved.filter(x => x.isOverbooking).length
      const current = this.info.multiple
        ? todayReserved.filter(x => !x.isOverbooking).reduce(function (a, b) {
          return a + Number(b.person)
        }, 0)
        : todayReserved.filter(x => !x.isOverbooking).length
      return {
        total: total,
        current: current || 0,
        overbooking: overbooking,
        isVisiable: total && typeof (total) === 'number'
      }
    },
    validate () {
      const isStaff = this.isStaff && this.isStaff.length > 0
      const count = this.info.multiple ? this.person : 1
      const date = this.reserve.date
      const authentication = this.$store.state.authentication
      const isCheckin = this.roomKey && authentication.k
      const person = this.person > 0
      const section = this.reserve.section !== ''
      const time = this.reserve.time !== '' && (!(this.status.current >= this.status.total) || this.status.current === 0)
      const place = this.reserve.place !== ''
      const seat = this.reserve.seat.length === count
      const multipleSeat = this.info.multiple && seat // 인원수에 맞게 모두 선택 했는지?
      const name = this.reserve.firstName !== '' && this.reserve.lastName !== ''
      const tel = !this.info.bookerTel || this.validatePhone.valid
      const email = !this.info.bookerEmail || this.reserve.email
      const preArrival = this.info.preArrival ? true : this.roomKey
      const limitPerDay = this.info.limitPerDay
      const limitPerOta = this.info.limitPerOta
      const reserveLimit = limitPerDay // true: 예약제한에 걸림 (이미 예약내역이 있음)
        ? this.guestReserve.filter(x => x.date === moment(date).format('YYYY-MM-DD')).length > 0
        : limitPerOta
          ? this.guestReserve.length > 0
          : false
      const possible = isStaff || !(isCheckin && date && reserveLimit) // 예약제한 (ota기반 1일or투숙일 기준)
      return {
        date: date,
        person: person,
        section: section,
        time: time,
        place: place,
        seat: seat,
        multipleSeat: multipleSeat,
        name: name,
        tel: tel,
        email: email,
        preArrival: preArrival,
        possible: possible,
        reserveLimit: reserveLimit,
        limitPerDay: limitPerDay && reserveLimit,
        limitPerOta: limitPerOta && reserveLimit,
        isStaff: isStaff,
        result: isStaff || (date && person && section && place && name && tel && email && preArrival && seat)
      }
    }
  },
  watch: {
    validate: {
      deep: true,
      handler (validate) {
        if (validate.date && validate.person && validate.time && validate.section && validate.place && validate.seat) {
          this.countryList = this.$refs.telInput ? this.$refs.telInput.allCountries : []
        }
      }
    },
    current: {
      deep: true,
      handler (data) {
        const section = this.space
        const isStaff = this.isStaff
        function getPlaceId (number, arr, isStaff) {
          const possibleRange = arr.filter(x => {
            return isStaff ? !x.disabled : !x.disabled && x.isPerson && x.isRemain && x.isSelectable
          }).sort(function (a, b) {
            return Number(a.max) - number < Number(b.max) - number ? -1 : Number(a.max) - number > Number(b.max) - number ? 1 : 0
          })
          return possibleRange[0].placeId
        }
        /**
         * 예약가능한 place인지 체크
         * disabled: 일시불가
         * isPerson: 인원수 수용 가능
         * isRemain: 해당시간 예약 가능
         * isSelectable: 예약 되어있음
         */
        function isSelectablePlace (placeObj) {
          return !placeObj.disabled && placeObj.isPerson && placeObj.isRemain && placeObj.isSelectable
        }
        if (!data.place) {
          this.reserve.place = ''
          this.reserve.seat = []
        }
        if (data.person > 0 && !isStaff) {
          // 선택지가 하나일 때 자동선택
          if (section.length === 1) {
            this.reserve.section = section[0].id
          }
          if (this.section.length === 1) {
            this.reserve.section = this.section[0].id
          }
          if (this.time && this.time.length === 1) {
            const time = this.time[0]
            this.reserve.time = time.timeId
          }
          if (this.place && this.place.length === 1) {
            const place = this.place[0]
            if (isSelectablePlace(place)) {
              this.reserve.place = place.placeId
            }
          }
          if (this.seat && this.seat.filter(x => x.isSelectable).length === 1) {
            const seat = this.seat.filter(x => x.isSelectable)[0]
            this.reserve.seat = seat.seatId
          }
          // 자동배정일 때
          if (data.section && data.section.autoAssign) {
            if (this.place.filter(x => (isSelectablePlace(x))).length > 0) {
              this.reserve.place = getPlaceId(data.person, this.place)
              this.setSeat()
            }
          }
          // 인원변경으로 선택했던 자리가 선택범위에서 벗어날 때 seat 초기화
          if (data.place && !(isSelectablePlace(data.place))) {
            this.reserve.place = ''
            this.reserve.seat = []
          }
        } else if (isStaff) {
          // 선택지가 하나일 때 자동선택
          if (section.length === 1) {
            this.reserve.section = section[0].id
          }
          if (this.section.length === 1) {
            this.reserve.section = this.section[0].id
          }
          if (this.time && this.time.length === 1) {
            const time = this.time[0]
            this.reserve.time = time.timeId
          }
          if (this.place && this.place.length === 1) {
            const place = this.place[0]
            this.reserve.place = place.placeId
          }
          if (this.seat && this.seat.length === 1) {
            const seat = this.seat[0]
            this.reserve.seat = seat.seatId
          }
          // 자동배정일 때
          if (data.section && data.section.autoAssign) {
            if (this.place.length > 0) {
              this.reserve.place = getPlaceId(data.person, this.place, isStaff)
              this.setSeat(isStaff)
            }
          }
        }
      }
    }
  },
  mounted () {
    this.getKey()
    setInterval(() => {
      this.timeNow = moment().format('HHmm')
    }, 1000)
  },
  data () {
    return {
      key: this.$store.state.authentication.k,
      openCountry: false,
      searchCountry: '',
      countryList: [],
      timeNow: '',
      reserve: {
        date: null,
        time: '',
        person: '',
        section: '',
        place: '',
        seat: [],
        firstName: '',
        lastName: '',
        tel: '',
        email: ''
      },
      calendarAttr: [
        {
          bar: 'orange',
          dates: new Date()
        }
      ],
      personInput: '',
      validatePhone: {},
      summaryOn: false,
      summary: null,
      summaryDisplay: {},
      space: [],
      reserved: [],
      possibleReservation: true,
      initMap: false,
      guestReserve: []
    }
  },
  methods: {
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    getReservationInfo () {
      const date = this.validate.date
      // 예약이 되어있는 seat의 시간별 체크
      function isReservedSeat (reserved, sectionId, seatId, timeId) {
        return reserved.filter(x => {
          return x.section === sectionId &&
            x.seat.find(s => s === seatId) &&
            x.time === timeId
        }).length === 0
      }
      function checkSelectable (arr) {
        return arr.filter(x => x.isSelectable).length > 0
      }
      if (date) {
        const data = {
          spaceId: this.info.id,
          date: moment(date).format('YYYY-MM-DD')
        }
        this.$store.commit('loading', true)
        this.$store.dispatch('reservation/getReservationRealtime', data).then((res) => {
          const reserved = res.map(x => {
            const content = x.ordersheet.content
            const seat = content.seats ? content.seats.map(s => s.seat.id) : [content.seat.id]
            return {
              orderId: x.order_uuid,
              section: content.section.id,
              place: content.place.id,
              seat: seat,
              time: content.time.id,
              ...(content.userInfo && content.userInfo.ota) && {
                ota: content.userInfo.ota
              },
              person: content.person,
              isOverbooking: seat.filter(x => x === '-1').length > 0
            }
          })
          const time = this.info.time
          const space = this.info.section.map(x => {
            return {
              ...x,
              place: x.place.map(p => {
                return {
                  ...p,
                  seat: p.seat.map(s => {
                    return {
                      ...s,
                      time: time.map(t => {
                        return {
                          ...t,
                          isSelectable: isReservedSeat(reserved, x.id, s.seatId, t.timeId)
                        }
                      })
                    }
                  })
                }
              })
            }
          }).map(x => {
            return {
              ...x,
              isSelectable: x.place.filter(p => {
                return p.seat.filter(s => {
                  return checkSelectable(s.time)
                }).length > 0
              }).length > 0,
              place: x.place.map(p => {
                return {
                  ...p,
                  isSelectable: p.seat.filter(s => {
                    return checkSelectable(s.time)
                  }).length > 0,
                  seat: p.seat.map(s => {
                    return {
                      ...s,
                      isSelectable: checkSelectable(s.time)
                    }
                  })
                }
              })
            }
          })
          // 예약 가능수 제한을 위한 (ota)예약현황
          if (!this.info.preArrival && (this.info.limitPerDay || this.info.limitPerOta)) {
            const ota = this.key
            this.$store.dispatch('reservation/getReservationRealtime', { spaceId: this.info.id, ota: ota }).then((res) => {
              if (res) {
                this.guestReserve = res.map(x => {
                  const content = x.ordersheet.content
                  return {
                    orderId: x.order_uuid,
                    date: content.date,
                    time: content.time.id
                  }
                })
              }
            })
          }
          this.reserved = reserved
          this.space = space
          this.$store.commit('loading', false)
        })
      }
    },
    setDateFormat (date) {
      return moment(date).format(this.dateFormat.toUpperCase())
    },
    updatePerson (e) {
      const person = regExp.numberOnly(e.target.value)
      this.personInput = person
    },
    setSeat (isStaff) { // seat 자동배정 예약가능한 자리 중 0번째
      const placeId = this.reserve.place
      const time = this.reserve.time
      const person = this.person
      const seat = this.validate.time ? this.place.find(x => x.placeId === placeId).seat.filter(s => {
        return s.time.find(t => t.timeId === time).isSelectable
      }) : []
      this.reserve.seat = this.info.multiple
        ? isStaff && seat.length < person
          ? []
          : seat.filter((x, i) => i < person).map(x => x.seatId) // 한자리씩 선택(다중선택)
        : isStaff && seat.length === 0
          ? []
          : [seat[0].seatId] // 한자리만 선택
    },
    activeSeat (data) {
      const count = this.info.multiple ? this.person : 1
      const length = this.reserve.seat.length
      function toggle (arr, id) {
        return arr.includes(id) ? arr.filter(x => x !== id) : [...arr, id]
      }
      function remove (arr, id) {
        return arr.filter(x => x !== id)
      }
      this.reserve.place = data.placeId
      if (count > 1) {
        if (count > length) {
          this.reserve.seat = toggle(this.reserve.seat, data.seatId)
        } else if (count === length && this.reserve.seat.includes(data.seatId)) {
          this.reserve.seat = remove(this.reserve.seat, data.seatId)
        }
      } else if (count === 1) {
        this.reserve.seat = [data.seatId]
      }
      // this.reserve.seat = toggle(this.reserve.seat, data.seatId)
      // this.reserve.seat = data.seatId
    },
    toggleCountry (isOpen) {
      this.openCountry = isOpen
      if (isOpen) {
        const findInput = this.$refs.searchInput
        if (findInput) {
          this.$nextTick(() => findInput.focus())
        }
      }
    },
    inputTel (number, telObj) {
      this.validatePhone = telObj
      this.reserve.tel = telObj.number
    },
    setSearchCountry () {
      const value = this.$refs.searchInput.value
      this.searchCountry = value
    },
    confirmSummary (summary) {
      if (summary === true) {
        this.onConfirm()
        this.summaryOn = true
      } else if (summary === false) {
        this.summary = null
        this.summaryOn = false
      } else if (summary === 'reservation') {
        this.submit()
      }
    },
    onConfirm () {
      const isOverbooking = this.isStaff
      const info = this.reserve
      const setInfo = this.info
      const setEmptyData = {
        id: '-1',
        name: langObj(setInfo.name)
      }
      const lang = this.lang
      const date = moment(info.date).format('YYYY-MM-DD')
      const displayDate = this.setDateFormat(info.date)
      const time = info.time
      const timeHhmm = `${time.substr(0, 2)}:${time.substr(2, 2)} ~ ${time.substr(4, 2)}:${time.substr(6, 2)}`
      const sectionId = info.section
      const section = setInfo.section && sectionId.length > 0 ? setInfo.section.find(x => x.id === sectionId) : setEmptyData
      const placeId = info.place
      const place = section.place && placeId.length > 0 ? section.place.find(x => x.placeId === placeId) : setEmptyData
      const seatId = info.seat
      const seat = section && place && place.seat && seatId.length > 0
        ? place.seat.find(x => seatId.includes(x.seatId)) || null
        : setEmptyData
      const authentication = this.$store.state.authentication
      const staff = `${authentication.staff}.${authentication.site}`
      const data = {
        userLanguage: lang,
        date: date,
        displayDate: displayDate,
        person: info.person === 'input' ? Number(this.person) : Number(info.person),
        space: { id: setInfo.id, space: setInfo.space, name: setInfo.name },
        section: { id: sectionId, name: section.name },
        place: { id: placeId, name: place.name },
        seat: { id: seatId, name: seat ? seat.name : null },
        seats: isOverbooking
          ? setInfo.multiple && this.person > info.seat.length
            ? setOverbooking(setInfo.section, sectionId, placeId, this.person, setEmptyData)
            : !setInfo.multiple && info.seat.length === 0
              ? setOverbooking(setInfo.section, sectionId, placeId, 1, setEmptyData)
              : getSeatInfo(setInfo.section, seatId)
          : getSeatInfo(setInfo.section, seatId),
        time: { id: info.time, name: timeHhmm },
        autoAssign: section.autoAssign,
        showPlaceName: section.showPlaceName,
        showSeatName: section.showSeatName,
        ...authentication.staff && {
          staff: staff
        },
        multiple: setInfo.multiple === true
      }
      const summaryDisplay = {
        autoAssign: section.autoAssign,
        placeName: section.showPlaceName,
        seatName: section.showSeatName
      }
      const userInfo = {
        firstName: info.firstName,
        lastName: info.lastName,
        ...setInfo.bookerTel && {
          phone: info.tel
        },
        ...setInfo.bookerEmail && {
          email: info.email
        }
      }
      function langObj (obj) {
        let result = {}
        const keys = Object.keys(obj)
        for (let i = 0; i < keys.length; i++) {
          result = { ...result, [keys[i]]: '-1' }
        }
        return result
      }
      /**
       * 좌석 직접지정의 경우
       * seat에 따라 parent인 place, section이 모두 다를 수가 있으므로
       * seatId로 parent data를 맵핑
       */
      function setOverbooking (arr, sectionId, placeId, person, setEmptyData) {
        let result = []
        const section = arr.find(x => x.id === sectionId)
        const place = section.place.find(x => x.placeId === placeId)
        for (let i = 0; i < person; i++) {
          result.push({
            section: {
              id: section.id,
              name: section.name
            },
            place: place
              ? { id: place.placeId, name: place.name }
              : { ...setEmptyData },
            seat: setEmptyData
          })
        }
        return result
      }
      function getSeatInfo (arr, seatIds, isOverbooking) {
        let result = []
        for (let i = 0; i < arr.length; i++) {
          const section = arr[i]
          for (let j = 0; j < section.place.length; j++) {
            const place = section.place[j]
            for (let k = 0; k < place.seat.length; k++) {
              const seat = place.seat[k]
              if (seatIds.includes(seat.seatId)) {
                result.push({
                  section: {
                    id: section.id,
                    name: section.name
                  },
                  place: {
                    id: place.placeId,
                    name: place.name
                  },
                  seat: {
                    id: seat.seatId,
                    name: seat.name
                  }
                })
              }
            }
          }
        }
        return result
      }
      this.summary = null
      this.summaryOn = true
      this.summary = { ...data, ...userInfo }
      this.summaryDisplay = summaryDisplay
    },
    submit () {
      const lang = this.lang
      const data = this.summary
      const location = window.location
      const site = this.$store.state.authentication.site
      const key = !this.info.preArrival ? { key: this.key } : null
      // 예약 전 한번 더 예약현황 체크
      const getReservedData = {
        spaceId: data.space.id,
        date: data.date,
        ...key
      }
      const setReservationData = {
        returnUrl: `${location.origin}${location.pathname}?site=${site}&frame=false#/${lang}/reservation/check/`,
        payload: data
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('reservation/getReservationRealtime', getReservedData).then((result) => {
        const reserved = result.find(x => {
          const content = x.ordersheet.content
          return (content.section.id === data.section.id) &&
            (content.place.id === data.place.id) &&
            (content.seats
              ? content.seats.map(x => x.seat.id).find(id => data.seat.id.includes(id))
              : Array.isArray(content.seat.id)
                ? content.seat.id.includes(data.seat.id)
                : content.seat.id === data.seat.id) &&
            (content.time.id === data.time.id)
        })
        this.$store.commit('loading', false)
        if (result) {
          if (reserved) {
            // 예약이 모두 찼습니다. 새로고침하여 다시 예약하시겠습니까?
            if (window.confirm(`${this.locale.reservation_full}\n${this.locale.confirm_reservation_reload}`)) {
              this.$emit('init')
            }
          } else {
            this.$store.commit('loading', true)
            this.$store.dispatch('reservation/setReservation', setReservationData).then((res) => {
              this.summaryOn = false
              this.summary = null
              if (res) {
                const reservationId = res
                this.$router.push({ name: 'reservationComplete', params: { lang: lang, reservationId: reservationId } })
              } else {
                alert(this.locale.alert_fail_reservation)
              }
              this.$store.commit('loading', false)
              this.$emit('init')
            })
          }
        } else {
          alert(this.alert_fail_reservation)
          this.$store.commit('loading', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.formGroup {
  position: relative;
  .translateTxt {
    position: absolute;
    bottom: 100%;
    left: 0;
    font-size: 0.1em;
    color: transparent;
    opacity: 0;
  }
}
.btns {
  position: relative;
  .validateMessage {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-bottom: 2px;
    padding: 2px 10px;
    text-align: center;
    white-space: nowrap;
    color: $color-white;
    border-radius: 20px;
    background-color: rgba($color-red, 0.7);
    transform: translate(-50%, -50%);
  }
}
.statusMessage {
  span {
    display: inline-block;
    position: relative;
    padding: 4px 10px;
    font-size: 0.85em;
    color: $color-white;
    white-space: nowrap;
    border-radius: 50px;
    background-color: $color-green;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 20px;
      width: 8px;
      height: 8px;
      margin-top: -4px;
      border-radius: 2px;
      background-color: $color-green;
      transform: rotate(45deg);
    }
    i {
      padding: 0 4px;
      color: $color-green;
      font-size: 0.85em;
      border-radius: 4px;
      background-color: $color-white;
      opacity: 0.9;
    }
  }
}
</style>
